import { SpaceSwitcher } from "@octopusdeploy/main-navigation";
import { AnalyticLinkLocationProvider } from "@octopusdeploy/portal-analytics";
import { links } from "@octopusdeploy/portal-routes";
import { useSpaceAwareNavigation } from "~/components/Navigation/SpaceAwareNavigation/useSpaceAwareNavigation";
import { isSpecificSpaceContext } from "~/components/SpaceLoader/SpaceLoader";
import type { SpaceContext } from "~/components/SpaceLoader/SpaceLoader";
import { useWorkflow } from "~/workflows/useWorkflow";
import { workflows } from "~/workflows/workflows";
interface SpaceSwitcherUpliftProps {
    spaceContext: SpaceContext;
}
export function SpaceSwitcherNavigationBarItem({ spaceContext }: SpaceSwitcherUpliftProps) {
    const { navigate } = useSpaceAwareNavigation();
    const startAddSpaceWorkflow = useWorkflow(workflows.addSpaceWorkflow);
    const currentSpace = isSpecificSpaceContext(spaceContext) ? spaceContext : undefined;
    return (<AnalyticLinkLocationProvider location={"Space Switcher"}>
            <SpaceSwitcher currentSpace={currentSpace} onNewSpaceRequested={() => startAddSpaceWorkflow((space) => navigate(links.spacePage.generateUrl({ currentSpaceId: space.Id })))}/>
        </AnalyticLinkLocationProvider>);
}
